import React from 'react';
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'


const MTMarkdown = ({style, children}) => {
  return (<div style={style}>
    {children && <ReactMarkdown
      linkTarget={'_blank'}
      rehypePlugins={[rehypeRaw]}>
      {children}
    </ReactMarkdown>}
  </div>);
};

export default MTMarkdown;
